import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';

function getLanguage() {
  return httpService.get(ApiUrl.LANGUAGE);
}

const obj = { getLanguage };
export default obj;
